import ValidService from "../../../service/ValidService";
let model = {};

// dữ liệu form
model.dataForm = {
  duyet: {
    //object, optional // Thông tin duyệt
    duoc_duyet: null, //boolean, optional // Cho biết điểm đến đã được duyệt hay chưa
    thoi_diem_duoc_duyet: null, //datetime, optional // Cho biết thời điểm điểm đến đã được duyệt
    nguoi_duyet_id: null //IdRef, optional // Mã người duyệt
  },
  loai_diem_den: null, //string, optional // Loại điểm đến
  thong_tin_chung: {
    //object, optional // Thông tin chung
    ten: null, //string, optional // Tên điểm đến
    anh: null, //IdRef, optional // Mã ảnh đại diện
    giay_to: {}, //object, optional // Thông tin giấy tờ định danh điểm đến
    dia_chi: {}, //object, optional // Thông tin địa chỉ
    nguoi_dai_dien: {} //object, optional // Thông tin người đại diện
  },

  du_lieu_khai_bao: {}, //object, optional // Dữ liệu khai báo khi đăng ký điểm đến
  nguoi_tao_id: null, //IdRef, optional // Mã người tạo
  thoi_diem_tao: null, //datetime, optional // Thời điểm tạo
  star: null,
  doi_tuong_id: null,
  count: null
};

// validation form
model.validForm = {
  duyet: {
    //object, optional // Thông tin duyệt
    duoc_duyet: [], //boolean, optional // Cho biết điểm đến đã được duyệt hay chưa
    thoi_diem_duoc_duyet: [], //datetime, optional // Cho biết thời điểm điểm đến đã được duyệt
    nguoi_duyet_id: [] //IdRef, optional // Mã người duyệt
  },
  loai_diem_den: [], //string, optional // Loại điểm đến
  thong_tin_chung: {
    //object, optional // Thông tin chung
    ten: [], //string, optional // Tên điểm đến
    anh: [] //IdRef, optional // Mã ảnh đại diện
  },
  so_sao: [],
  du_lieu_khai_bao: [], //object, optional // Dữ liệu khai báo khi đăng ký điểm đến
  nguoi_tao_id: [], //IdRef, optional // Mã người tạo
  thoi_diem_tao: [], //datetime, optional // Thời điểm tạo
  star: [],
  doi_tuong_id: [],
  count: []
};

// dữ liệu mẫu các form khác
model.dataFormOther = {
  giay_to: {
    //object, optional // Thông tin giấy tờ định danh điểm đến
    so_giay_to: null, //string, optional // Mã số thuế/Mã số doanh nghiệp
    noi_cap: null, //string, optional // Nơi cấp
    ngay_cap: null, //datetime, optional // Ngày cấp
    scan: [], //array of IdRef, optional // Danh sách mã ảnh scan
    dia_chi: null //string, optional // Địa chỉ trên đăng ký kinh doanh
  },
  dia_chi: {
    //object, optional // Thông tin địa chỉ
    quoc_gia: null, //string, optional // Quốc gia
    quoc_tich_id: null, //IdRef, optional // Mã quốc tịch
    tinh: null, //string, optional // Tên tỉnh
    tinh_id: null, //IdRef, optional // Mã tỉnh
    xa: null, //string, optional // Tên xa
    xa_id: null, //IdRef, optional // Mã xã
    dia_chi: null, //string, optional // Địa chỉ giao dịch
    kinh_do: null, //double, optional // Kinh độ
    vi_do: null //double, optional // Vĩ độ
  },
  nguoi_dai_dien: {
    //object, optional // Thông tin người đại diện
    ho_ten: null, //string, optional // Họ và tên
    chuc_vu: null, //string, optional // Chức vụ
    ngay_sinh: null, //datetime, optional // Ngày sinh
    so_giay_to: null, //string, optional // Số CMT/ Căn cước/ Hộ chiếu
    gioi_tinh: null, //integer, optional // Giới tính
    dia_chi: null, //string, optional // Địa chỉ
    dien_thoai: null, //string, optional // Điện thoại
    email: null //string, optional // Email
  },
  fileUploadOption: {
    AnhDaiDien: {
      limit: 1,
      accept: ".jpg, .png, .jpeg",
      dialogImageUrl: "",
      dialogVisible: false,
      fileList: []
    },
    AnhGiayTo: {
      limit: null,
      accept: "",
      dialogImageUrl: "",
      dialogVisible: false,
      fileList: []
    }
  }
};

// validation các form khác
model.validFormOther = {
  giay_to: {
    //object, optional // Thông tin giấy tờ định danh điểm đến
    so_giay_to: [], //string, optional // Mã số thuế/Mã số doanh nghiệp
    noi_cap: [], //string, optional // Nơi cấp
    ngay_cap: [], //datetime, optional // Ngày cấp
    scan: [], //array of IdRef, optional // Danh sách mã ảnh scan
    dia_chi: [] //string, optional // Địa chỉ trên đăng ký kinh doanh
  },
  dia_chi: {
    //object, optional // Thông tin địa chỉ
    quoc_gia: [], //string, optional // Quốc gia
    quoc_tich_id: [], //IdRef, optional // Mã quốc tịch
    tinh: [], //string, optional // Tên tỉnh
    tinh_id: [], //IdRef, optional // Mã tỉnh
    xa: [], //string, optional // Tên xa
    xa_id: [], //IdRef, optional // Mã xã
    dia_chi: [], //string, optional // Địa chỉ giao dịch
    kinh_do: [], //double, optional // Kinh độ
    vi_do: [] //double, optional // Vĩ độ
  },
  nguoi_dai_dien: {
    //object, optional // Thông tin người đại diện
    ho_ten: [], //string, optional // Họ và tên
    chuc_vu: [], //string, optional // Chức vụ
    ngay_sinh: [], //datetime, optional // Ngày sinh
    so_giay_to: [], //string, optional // Số CMT/ Căn cước/ Hộ chiếu
    gioi_tinh: [], //integer, optional // Giới tính
    dia_chi: [], //string, optional // Địa chỉ
    dien_thoai: [], //string, optional // Điện thoại
    email: [] //string, optional // Email
  }
};

model.tableRules = {
  data: [],
  type: "safe_place",
  sort_type: 1,
  lengthMenu: [10, 20, 50, 100, 500],
  allowPaging: true,
  allowSorting: true,
  allowSelect: false,
  showFormSearch: false,
  showUrl: true,
  total: 0,
  page: 1,
  limit: 10,
  offset: 0,
  sort: "star",
  defaultSort: ["star", "ascending"],
  filters: "",
  recordSelected: [],
  dataSearch: {
    value: {
      "duyet.duoc_duyet": "",
      loai_diem_den: "",
      "thong_tin_chung.ten": "",
      "du_lieu_khai_bao.user_account": "",
      "thong_tin_chung.giay_to.so_giay_to": "",
      nguoi_tao_id: "",
      thoi_diem_tao: "",
      star: "",
      count: "",
      "thong_tin_chung.dia_chi.tinh_id": null, // optional Mã tỉnh
      "thong_tin_chung.dia_chi.xa_id": null
    },
    valid: {
      "duyet.duoc_duyet": [],
      loai_diem_den: [],
      "thong_tin_chung.ten": [],
      "du_lieu_khai_bao.user_account": [],
      nguoi_tao_id: [],
      thoi_diem_tao: [],
      star: [],
      count: [],
      thong_tin_chung: {
        dia_chi: {
            "tinh_id": null, // optional Mã tỉnh
            "xa_id": null,
        }
    }
    },
    operator: {
      "thong_tin_chung.ten": ":regex_i:", //:regex:, $vn_text=Viêt nam
      "du_lieu_khai_bao.user_account": ":regex_i:",
      "thong_tin_chung.giay_to.so_giay_to": ":regex_i:",
      thoi_diem_tao: ">=",
      star: ">=",
      count: ">="
    }
  }
};

export default model;
